import React from "react";

export function lazyWithRetry<T extends React.ComponentType<any>>(
  importFn: () => Promise<{ default: T }>
) {
  return React.lazy(() =>
    importFn().catch((error) => {
      const key = "chunk-retry";
      if (!sessionStorage.getItem(key)) {
        sessionStorage.setItem(key, "1");
        window.location.reload();
        // Return a dummy component that never renders (page reloads first)
        return { default: (() => null) as unknown as T };
      }
      sessionStorage.removeItem(key);
      throw error;
    })
  );
}
